import { useInterestsQuery, useInterestsUpdateMutation } from '../../../api/activationObject/hooks'
import { ApiInterests } from '../../../api/activationObject/types'
import useAppAuth from '../../providers/AppAuthProvider/hooks/useAppAuth'
import { ThanksProps, useThankProps } from '../types'

const defaultInterests: ApiInterests = {
    videoServicesInterest: false,
    audioServicesInterest: false,
    carSecurityInterest: false,
    personSecurityInterest: false,
}

const useThanx = (props: useThankProps): ThanksProps => {
    const auth = useAppAuth()
    const { data: interests } = useInterestsQuery(auth.synonym)
    const { mutate } = useInterestsUpdateMutation()

    const handleSetInterest = (key: keyof ApiInterests) => {
        if (auth.synonym) {
            const newInterests = interests ? { ...interests } : defaultInterests
            newInterests[key] = !newInterests[key]
            mutate({ ...newInterests, synonym: auth.synonym })
        }
    }

    return {
        interests: interests || defaultInterests,
        handleSetInterest,
    }
}

export default useThanx
